<template>
  <div class="login-container">
    <form @submit.prevent="handleLogin" class="login-form">
      <h2>Anmelden</h2>
      
      <div class="form-group">
        <label for="email">E-Mail</label>
        <input 
          type="email" 
          id="email"
          v-model="email"
          required
        >
      </div>

      <div class="form-group">
        <label for="password">Passwort</label>
        <input 
          type="password" 
          id="password"
          v-model="password"
          required
        >
      </div>

      <button type="submit" class="login-button">Anmelden</button>
      
      <p v-if="error" class="error-message">{{ error }}</p>
    </form>
  </div>
</template>

<script>
export default {
  name: 'LoginView',
  data() {
    return {
      email: '',
      password: '',
      error: null
    }
  },
  async created() {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    
    if (token) {
      try {
        const response = await fetch(`${process.env.VUE_APP_BASE_URL}/agency/app/auth/checkAuth`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        });

        if (response.ok) {
          localStorage.setItem('approvalSystemToken', token);
          localStorage.setItem('isAuthenticated', 'true');
          this.$router.push({ name: 'freigabe' });
        }
      } catch (err) {
        // Bei ungültigem Token oder Fehler einfach zum normalen Login übergehen
        return;
      }
    }
  },
  methods: {
    async handleLogin() {
      try {
        this.error = null;
        
        const response = await fetch(`${process.env.VUE_APP_BASE_URL}/agency/app/auth/login`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            userName: this.email,
            password: this.password
          })
        });

        if (!response.ok) {
          if(response.status == 403){
            throw new Error('Anmeldung fehlgeschlagen. Bitte überprüfen Sie Ihre Eingaben.');
          }
          if(response.status == 404){
            throw new Error('Anmeldung fehlgeschlagen. Bitte überprüfen Sie Ihre Eingaben.');
          }
          if(response.status == 500){
            throw new Error('Das System scheint nicht Online zu sein. Bitte wenden Sie sich an die Unvergessen Agentur');
          }
          if(response.status == 401){
            localStorage.removeItem('approvalSystemToken')
            localStorage.removeItem('isAuthenticated')
            localStorage.removeItem('userData')
          }
          const errorData = await response.json();
          throw new Error(errorData.message || 'Login fehlgeschlagen');
        }
        const data = await response.json();

        // Token und Auth-Status im localStorage speichern
        localStorage.setItem('approvalSystemToken', data.token);
        localStorage.setItem('isAuthenticated', 'true');
        localStorage.setItem('userData', JSON.stringify({
          email: this.email,
          lastLogin: new Date().toISOString()
        }));


        
        // Zur Freigabe-Seite weiterleiten
        this.$router.push({ name: 'freigabe' });
        } catch (err) {
        this.error = err.message;
        console.error('Login error:', err);
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  padding: 20px;
}

.login-form {
  background: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 400px;
}

.form-group {
  margin-bottom: 1rem;
}

label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: bold;
}

input {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
}

.login-button {
  width: 100%;
  padding: 0.75rem;
  background-color: #42b983;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  margin-top: 1rem;
}

.login-button:hover {
  background-color: #3aa876;
}

.error-message {
  color: #dc3545;
  margin-top: 1rem;
  text-align: center;
}
</style>
